import React from 'react';
import Commercial from './Commercial';
import Collapse from '@mui/material/Collapse';
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import WidgetInputText from '../../../components/widgets/WidgetInputText';
import WidgetSelect from '../../../components/widgets/WidgetSelect';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import CONFIG from '../../../config';

function ListCommerciaux() {
  const navigate = useNavigate();

  function downloadFile(fileName, urlData) {
    var aLink = document.createElement('a');
    aLink.download = fileName;
    aLink.href = urlData;

    var event = new MouseEvent('click');
    aLink.dispatchEvent(event);
  }

  const [secteurOption, setSecteurOption] = React.useState({});
  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/get_secteurs', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            let res = {};
            res["osef"] = "Peu importe";
            for (let i = 0; i < response.data.length; i++) {
              const secteurItem = response.data[i];
              res[secteurItem.toLowerCase()] = secteurItem;
            }
            res["autre"] = "Autre...";

            setSecteurOption(res);
            break;

          default:
            break;
        }
      })
      .catch((e) => {

      });
  }, []);

  const [displayFilters, setDisplayFilters] = React.useState(false);

  const [nom, setNom] = React.useState(null);
  const [prenom, setPrenom] = React.useState(null);
  const [secteur, setSecteur] = React.useState(null);
  const [disponibilite, setDisponibilite] = React.useState(null);
  const [tri, setTri] = React.useState(null);
  const [commerciaux, setCommerciaux] = React.useState(null);

  const applyFilter = (data) => {
    return data.filter((x) => (
      x.nom.toLowerCase().includes(nom?.value.toLowerCase())
      && x.prenom.toLowerCase().includes(prenom?.value.toLowerCase())
      && (['', 'osef', 'autre'].includes(secteur?.value) || x.informations_admin.secteur.toLowerCase() === secteur?.value.toLowerCase())
      && (['', 'osef'].includes(disponibilite?.value) || x.informations_admin.disponibilite.toLowerCase() === disponibilite?.value.toLowerCase() ||
        (['1d', '2d', '3d+'].includes(x.informations_admin.disponibilite) && disponibilite?.value === 'dispo'))
    ))
  }

  const applySort = (data, sortType) => {
    return data.sort((a, b) => {
      switch (sortType) {
        case "nom_up":
          return (a.nom > b.nom) ? 1 : -1;
        case "nom_down":
          return (a.nom < b.nom) ? 1 : -1;
        case "prenom_up":
          return (a.prenom > b.prenom) ? 1 : -1;
        case "prenom_down":
          return (a.prenom < b.prenom) ? 1 : -1;
        case "secteur_up":
          return (a.informations_admin.secteur > b.informations_admin.secteur) ? 1 : -1;
        case "secteur_down":
          return (a.informations_admin.secteur < b.informations_admin.secteur) ? 1 : -1;
        case "montant_up":
          return (a.informations_admin.prime > b.informations_admin.prime) ? 1 : -1;
        case "montant_down":
          return (a.informations_admin.prime < b.informations_admin.prime) ? 1 : -1;
        case "dispo_up":
          return ({ 'osef': -1, 'conge': -2, '0d': 0, '1d': 1, '2d': 2, '3d+': 3 }[a.informations_admin.disponibilite] > { 'osef': -1, 'conge': -2, '0d': 0, '1d': 1, '2d': 2, '3d+': 3 }[b.informations_admin.disponibilite]) ? 1 : -1;
        case "dispo_down":
          return ({ 'osef': -1, 'conge': -2, '0d': 0, '1d': 1, '2d': 2, '3d+': 3 }[a.informations_admin.disponibilite] < { 'osef': -1, 'conge': -2, '0d': 0, '1d': 1, '2d': 2, '3d+': 3 }[b.informations_admin.disponibilite]) ? 1 : -1;
        case "cours_up":
          return (a.informations_admin.nb_clients_attribue > b.informations_admin.nb_clients_attribue) ? 1 : -1;
        case "cours_down":
          return (a.informations_admin.nb_clients_attribue < b.informations_admin.nb_clients_attribue) ? 1 : -1;
        case "propose_up":
          return (a.informations_admin.nb_clients_propose > b.informations_admin.nb_clients_propose) ? 1 : -1;
        case "propose_down":
          return (a.informations_admin.nb_clients_propose < b.informations_admin.nb_clients_propose) ? 1 : -1;
        case "valide_up":
          return (a.informations_admin.nb_clients_valide > b.informations_admin.nb_clients_valide) ? 1 : -1;
        case "valide_down":
          return (a.informations_admin.nb_clients_valide < b.informations_admin.nb_clients_valide) ? 1 : -1;
      }
    })
  }

  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/get_all_commercial', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            setCommerciaux(response.data);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  }, []);

  return (
    <>
      {commerciaux !== null &&
        <>
          <div className='m-6 grid grid-cols-12 gap-x-4 shrink-0 w-100 bg-white my-shadow'>
            <div className='col-span-12 grid grid-cols-12 p-6 hover:bg-gray-100 cursor-pointer rounded-xl' onClick={() => setDisplayFilters(!displayFilters)}>
              <div className='col-span-6 w-full flex items-center'>
                <div className='inline-block'><FilterListIcon /></div>
                <div className='inline-block'><h3>&nbsp;Filtres & tris</h3></div>
              </div>
              <div className='col-span-6 w-full flex items-center justify-end'>
                <div className='inline-block'>{(!displayFilters) ? <ExpandMoreIcon fontSize="large" /> : <ExpandLessIcon fontSize="large" />}</div>
              </div>
            </div>
            <div className='col-span-12 w-full px-6 shadow-inner shadow-gray-100 bg-gray-50'>
              <Collapse in={displayFilters}>
                <hr className='mb-6'></hr>
                <div className='w-full grid grid-cols-12 gap-4 pb-2'>
                  <div className='col-span-3 w-full mb-4'>
                    <WidgetInputText state={nom} setState={setNom} id={'nom'} text={"Nom"} />
                  </div>

                  <div className='col-span-3 w-full mb-4'>
                    <WidgetInputText state={prenom} setState={setPrenom} id={'prenom'} text={"Prénom"} />
                  </div>

                  <div className='col-span-3 w-full mb-4'>
                    <WidgetSelect state={secteur} setState={setSecteur} id={'secteur'} text={"Secteur"}
                      options={secteurOption}
                    />
                  </div>

                  <div className='col-span-3 w-full mb-4'>
                    <WidgetSelect state={disponibilite} setState={setDisponibilite} id={'disponibilite'} text={"Disponibilités"}
                      options={{
                        'osef': "Peu importe",
                        'dispo': "Disponible",
                        '0d': "Non-disponible",
                        'conge': "En congé"
                      }}
                    />
                  </div>

                  <div className='col-span-3 w-full mb-4'>
                    <WidgetSelect state={tri} setState={setTri} id={'tri'} text={"Tri"} value={"nom_down"}
                      options={{
                        'nom_up': "Nom ↑",
                        'nom_down': "Nom ↓",
                        'prenom_up': "Prénom ↑",
                        'prenom_down': "Prénom ↓",
                        'secteur_up': "Secteur ↑",
                        'secteur_down': "Secteur ↓",
                        'montant_up': "Montant ↑",
                        'montant_down': "Montant ↓",
                        'dispo_up': "Disponibilités ↑",
                        'dispo_down': "Disponibilités ↓",
                        'cours_up': "Clients en cours ↑",
                        'cours_down': "Clients en cours ↓",
                        'propose_up': "Clients proposés ↑",
                        'propose_down': "Clients proposés ↓",
                        'valide_up': "Clients validés ↑",
                        'valide_down': "Clients validés ↓",
                      }}
                    />
                  </div>
                </div>
              </Collapse>
            </div>
          </div>



          <div className='m-6 grid grid-cols-12 gap-x-4 shrink-0 p-6 w-100 bg-white my-shadow'>
            <div className='divide-x col-span-12 grid grid-cols-12 gap-x-2 shrink-0 p-2 mb-2 bg-gray-300 rounded-md my-shadow'>
              <div className='col-span-2 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                <b>Nom</b>
              </div>
              <div className='col-span-2 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                <b>Prénom</b>
              </div>
              <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                <b>Secteur</b>
              </div>
              <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                <b>Disponibilité</b>
              </div>
              <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                <b>En cours</b>
              </div>
              <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                <b>Proposés</b>
              </div>
              <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                <b>Validés</b>
              </div>
              <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                <b>Externe</b>
              </div>
              <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                <b>Salaire</b>
              </div>
              <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
                <b>Prime</b>
              </div>
            </div>

            {applySort(applyFilter(commerciaux), tri?.value).map((x) => <Commercial key={x.nom} data={x}></Commercial>)}

            <div className='col-span-12 w-full pt-4 text-right'>
              <div className='pr-2 inline-block'>
                <Button variant='outlined' onClick={() => {
                  let payload = {
                    nom: nom.value,
                    prenom: prenom.value,
                    secteur: secteur.value,
                    dispo: disponibilite.value,
                  }
                  axios.post(CONFIG.API_URL + '/api/extract_csv_commercial', payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                    .then((response) => {
                      switch (response.status) {
                        case 200:
                          downloadFile('commerciaux.csv', 'data:text/csv;charset=UTF-8,' + encodeURIComponent(response.data));
                          break;

                        default:
                          break;
                      }
                    })
                    .catch((e) => {
                      let response = e.response;

                      if (response === undefined) {
                        alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                        return;
                      }

                      switch (response.status) {
                        default:
                          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                          break;
                      }
                    });
                }}>
                  Extraire en CSV
                </Button>
              </div>
              <div className='inline-block'>
                <Button variant='contained' onClick={() => {
                  var win = window.open();
                  applySort(applyFilter(commerciaux), tri?.value).map(x => win.document.write(x.email + "<br>"));
                  win.focus();
                }}>
                  Extraire les emails
                </Button>
              </div>
            </div>
          </div>
        </>
      }
    </>
  );
}

export default ListCommerciaux;